<template>
  <v-card class="mx-auto" max-width="100%" style="margin-bottom: 10px">
    <v-toolbar dense elevation="1">
      <v-toolbar-title
        title
        :class="$vuetify.breakpoint.mobile ? 'toolbar-title-mobile' : ''"
        >Criar nova conta</v-toolbar-title
      >
    </v-toolbar>
    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <fieldset style="border-radius: 5px" class="pa-3">
          <legend>Informações básicas</legend>
          <v-row>
            <v-col>
              <v-text-field
                label="Nome completo"
                v-model="form.name"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                label="Gênero"
                v-model="form.gender"
                :items="genders"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nome social"
                v-model="form.social_name"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nome da mãe"
                v-model="form.mother"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nome do pai"
                v-model="form.father"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Naturalidade"
                v-model="form.natural"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="Nacionalidade"
                v-model="form.from"
                :items="paises"
                item-text="gentilico"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="2" class="pa-0">
              <v-switch
                v-model="form.indigena"
                label="Sou Indígena"
                outlined
                dense
                hide-details="auto"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <DatePicker
                :class="nascimentoError ? 'date-error' : ''"
                format="DD/MM/YYYY"
                style="width: 100%"
                v-model="form.birthday"
                type="date"
                :input-attr="{ rules: 'requiredRule' }"
                valueType="date"
                placeholder="Data de nascimento"
                @pick="nascimentoError = false"
              />
              <span
                v-if="nascimentoError"
                class="v-messages theme--light error--text ml-3"
                >Informe a data de nascimento</span
              >
            </v-col>
            <v-col cols="12" md="9" v-if="form.from !== 'Brasileira'">
              <v-text-field
                label="Passaporte"
                :rules="requiredRule"
                v-model="form.passport"
                outlined
                dense
                hide-details="auto"
                :key="form.from"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="form.from === 'Brasileira'">
              <v-text-field
                label="CPF"
                v-model="form.cpf"
                v-mask="'###.###.###-##'"
                :rules="cpfRule"
                outlined
                dense
                hide-details="auto"
                :key="form.from"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="form.from === 'Brasileira'">
              <v-text-field
                label="RG"
                v-model="form.rg"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="form.from === 'Brasileira'">
              <v-select
                label="Estado emissor"
                v-model="form.rg_uf"
                :items="ufs"
                item-text="nome"
                item-value="sigla"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
        </fieldset>

        <fieldset
          v-if="form.indigena"
          style="border-radius: 5px"
          class="pa-3 mt-2"
        >
          <legend>Indígena</legend>
          <v-row>
            <v-col>
              <v-select
                label="Povo/Etnia"
                v-model="form.povo"
                :rules="requiredRule"
                :items="povos"
                outlined
                dense
                hide-details="auto"
              >
                ></v-select
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Aldeia"
                v-model="form.aldeia"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Rua"
                v-model="address_aldeia.rua"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Número"
                v-model="address_aldeia.numero"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Cidade"
                v-model="address_aldeia.cidade"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                label="Estado"
                v-model="address_aldeia.estado"
                :items="ufs"
                item-text="nome"
                item-value="sigla"
                outlined
                dense
                hide-details="auto"
              >
              </v-select>
            </v-col>
          </v-row>
        </fieldset>

        <fieldset style="border-radius: 5px" class="pa-3 mt-2">
          <legend>Endereço</legend>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                label="CEP"
                @blur="consultaCep(form.cep)"
                v-mask="'#####-###'"
                v-model="form.cep"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Endereço"
                v-model="address.street"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Número"
                v-model="address.street_number"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Bairro"
                v-model="address.neighborhood"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Cidade"
                v-model="form.city"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="Estado"
                v-model="form.state"
                :items="ufs"
                item-text="nome"
                item-value="sigla"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
                v-if="form.country === 'Brasil'"
              >
              </v-select>
              <v-text-field
                label="Estado"
                v-model="form.state"
                outlined
                dense
                hide-details="auto"
                v-else
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="País"
                v-model="form.country"
                :items="paises"
                item-text="nome_pais"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-select>
            </v-col>
          </v-row>
        </fieldset>

        <fieldset style="border-radius: 5px" class="pa-3">
          <legend>Contatos</legend>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Celular"
                v-mask="'(##) #####-####'"
                v-model="form.telephone"
                :rules="telephoneRule"
                outlined
                dense
                hide-details="auto"
                v-if="form.country === 'Brasil'"
                :key="form.country"
              >
              </v-text-field>
              <v-text-field
                label="Celular"
                v-model="form.telephone"
                :rules="requiredRule"
                outlined
                dense
                hide-details="auto"
                v-else
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Whatsapp"
                v-mask="'(##) #####-####'"
                v-model="form.zap"
                :rules="zapRule"
                outlined
                dense
                hide-details="auto"
                v-if="form.country === 'Brasil'"
                :key="form.country"
              >
              </v-text-field>
              <v-text-field
                label="Whatsapp"
                v-model="form.zap"
                outlined
                dense
                hide-details="auto"
                v-else
              >
              </v-text-field>
            </v-col>
          </v-row>
        </fieldset>

        <fieldset style="border-radius: 5px" class="pa-3 mb-5">
          <legend>Informações de login</legend>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="E-mail"
                v-model="form.email"
                :rules="emailRules"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Repita o E-mail"
                v-model="form.confirmEmail"
                :rules="confirmEmailRule"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Senha"
                v-model="form.password"
                :rules="requiredRule"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Confirmação de senha"
                v-model="form.confirmPassword"
                :rules="confirmPasswordRule"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-row justify="end" class="pa-3">
        <v-btn
          class="my-1 mx-1"
          :block="$vuetify.breakpoint.mobile"
          color="primary"
          elevation="0"
          @click="$router.go(-1)"
        >
          Cancelar</v-btn
        >
        <v-btn
          class="my-1 mx-1"
          :block="$vuetify.breakpoint.mobile"
          elevation="0"
          dark
          color="green"
          @click="createAccount"
          >Criar conta</v-btn
        >
      </v-row>
    </v-card-actions>

    <LoadingDialog :loading="loadingDialog" />
    <v-snackbar
      v-model="snackbar"
      timeout="-1"
      :color="errorMsg ? 'red darken-2' : 'green darken-2'"
    >
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn elevation="0" text v-bind="attrs" @click="login()">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import LoadingDialog from "@/components/LoadingDialog";
import {app} from "../services/feathers";
import auth from "../services/auth_handler";
import genders from "../utils/genders";
import validateCpf from "../utils/validateCpf";
import ufs from "../utils/ufs";
import povos from "../utils/indigena";
import paises from "../utils/paises";
import axios from "axios";

export default {
  metaInfo: {
    title: "Nova Conta",
  },
  components: { LoadingDialog },
  props: ["next"],
  data() {
    return {
      paises: paises.map((e) => {
        return {
          gentilico: e.gentilico.charAt(0).toUpperCase() + e.gentilico.slice(1),
          nome_pais: e.nome_pais,
        };
      }),
      nascimentoError: false,
      authData: "",
      errorMsg: false,
      snackbar: false,
      snackbarMsg: "",
      loadingDialog: false,
      formValid: false,
      showPassword: false,
      ufs: ufs,
      genders: genders,
      povos: povos,
      form: {
        from: "Brasileira",
        country: "Brasil",
        password: "",
        confirmPassword: "",
        confirmEmail: "",
      },
      address: { street: "", neighborhood: "", city: "", state: "" },
      address_aldeia: { rua: "", numero: "", cidade: "", estado: "" },
      emailRules: [
        (v) => !!v || "É necessário um e-mail",
        (v) =>
          //eslint-disable-next-line
          /^(?=.{1,254}$)(?=.{1,64}@)(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
            v
          ) || "O e-mail deve ser válido",
      ],
      requiredRule: [
        (v) =>
          v && v.trim().length >= 2 ? true : "É necessário inserir um dado",
      ],
      telephoneRule: [
        (v) => !!v || "É necessário inserir um telefone válido",
        (v) => /.{15}$/.test(v) || "O telefone informado está incompleto",
      ],
      zapRule: [
        (v) => !v || /.{15}$/.test(v) || "O telefone informado está incompleto",
      ],
      cpfRule: [
        (v) => !!v || "É necessário inserir um CPF",
        (v) => /.{14}$/.test(v) || "O CPF informado está incompleto",
        (v) => validateCpf(v) || "O CPF informado é inválido",
      ],
      confirmPasswordRule: [
        (v) => v === this.form.password || "As senhas devem coincidir",
        (v) => !!v || "É necessário inserir um dado",
      ],
      confirmEmailRule: [
        (v) => v === this.form.email || "Os emails devem coincidir",
        (v) => !!v || "É necessário um e-mail",
        (v) =>
          //eslint-disable-next-line
          /^(?=.{1,254}$)(?=.{1,64}@)(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
            v
          ) || "O e-mail deve ser válido",
      ],
    };
  },
  methods: {
    async consultaCep(cep) {
      this.loadingDialog = true;
      try {
        if (cep.length === 9) {
          const endereco = await axios.get(
            `https://viacep.com.br/ws/${this.form.cep}/json/`
          );
          if (!endereco.erro) {
            this.address.street = endereco.data.logradouro;
            this.address.neighborhood = endereco.data.bairro;
            this.form.city = endereco.data.localidade;
            this.form.state = endereco.data.uf;
          }
        }
      } catch (error) {
        console.log(error);
      }

      this.loadingDialog = false;
    },
    async login() {
      if (this.authData._id) {
        return await auth.login(
          { email: this.form.email, password: this.form.password },
          false,
          this.next
        );
      } else {
        this.snackbar = false;
        return null;
      }
    },
    async createAccount() {
      this.form.address = this.address;
      this.form.address_aldeia = this.address_aldeia;
      this.$refs.form.validate();

      if (
        isNaN(new Date(this.form.birthday)) ||
        this.form.birthday === null ||
        this.form.birthday === undefined
      ) {
        this.nascimentoError = true;
      } else {
        this.nascimentoError = false;
      }

      if (this.formValid && !this.nascimentoError) {
        const form = JSON.parse(JSON.stringify(this.form));
        
        // if (form.from === "Brasil")
        form.cpf = this.form.cpf.replaceAll(".", "").replace("-", "");
        try {
          this.loadingDialog = true;
          this.authData = await app.service("users").create(form);
          if (this.authData._id) {
            this.snackbarMsg = "Conta criada com sucesso.";
            this.snackbar = true;
          }
        } catch (error) {
          if (error.name === "Conflict") {
            let errorList = "";
            Object.keys(error.errors).forEach((k) => {
              if (k === "cpf") {
                errorList += `O CPF ${this.form.cpf} já está cadastrado.`;
              } else {
                errorList += `O ${k} ${this.form[k]} já está cadastrado.`;
              }
            });
            this.snackbarMsg = errorList;
          } else {
            this.snackbarMsg =
              "Falha ao realizar operação, por favor tente novamente.";
          }
          console.log(error);
          this.errorMsg = true;
          this.snackbar = true;
        }
        this.loadingDialog = false;
      }
    },
  },
};
</script>
